<template>
  <div class="market-couponList-create">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="150px">
      <div class="base-config">
        <el-form-item label="商品名称" prop="productName">
          <span>{{form.productName?form.productName:'---'}}</span>
        </el-form-item>
        <el-form-item label="商品图片" prop="pictureUrl">
          <UploadImg name="pictureUrl" @getUploadFile="getUploadFile" :uploadUrl="form.pictureUrl" desc="建议：上传99*90（2倍或3倍）jpg、png、jpeg图片"></UploadImg>
        </el-form-item>
         <el-form-item label="商品类型" prop="type">
            <span>{{onProductType(form.type)}}</span>
        </el-form-item>
         <el-form-item label="品牌" prop="typeName">
          <span>{{form.typeName?form.typeName:'---'}}</span>
        </el-form-item>
         <el-form-item label="成本价" prop="price">
          <span>{{form.price ? form.price : (form.price === 0? form.price : '---')}}</span>
        </el-form-item>
        <el-form-item label="官方价" prop="officialPrice">
          <span>{{form.officialPrice ? form.officialPrice : (form.officialPrice === 0? form.officialPrice : '---')}}</span>
        </el-form-item>
         <el-form-item label="库存" prop="stock">
            <span>{{form.stock ? form.stock : (form.stock === 0? form.stock : '---')}}</span>
        </el-form-item>
        <el-form-item label="使用须知" prop="remark">
          <div style="border: 1px solid #ccc; margin-top: 10px;">
            <!-- 工具栏 -->
            <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editor"
              :defaultConfig="toolbarConfig"
            />
            <!-- 编辑器 -->
            <Editor
              style="height: 400px; overflow-y: hidden;"
              :defaultConfig="editorConfig"
              v-model="form.remark"
              @onCreated="onCreated"
            />
          </div>
        </el-form-item>
      </div>
    </el-form>

    <div class="footer">
      <el-button @click="onBack" class="mr20">取消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="submitLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import editor from '@/mixins/editor'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import UploadImg from '@/components/UploadImg/index'
import {api_getWelfareItemDetail,api_putWelfareItemUpdate} from '@/api/market'
import { api_postFileUpload } from "@/api/common";

export default {
  name: "mwcreate",
  components: {
    UploadImg,
    AuthButton,
    Editor,
    Toolbar,
  },
  mixins: [ editor ],
  data() {
    const checkImage = (rule, value, callback) => {
      if (!this.form.pictureUrl) {
        callback(new Error('请上传图片'))
      }else {
        callback()
      }
    }
    return {
      isAdmin: false, // 是否是超级管理员
      isEditPage: false, // 是否是编辑页面
      submitLoading: false,
      form: {
      },
      rules: {
        pictureUrl: [{ validator: checkImage }],
        remark: [{required: true, message: '请输入使用须知'}],
      },
    };
  },

  created() {
    if(this.$route.query.id){
      this.isEditPage = true
      this.getWelfareDetail()
    }
    this.isAdmin = JSON.parse(localStorage.getItem('USER_INFO')).admin
  },

  methods: {
    // 获取券详情
    async getWelfareDetail() {
      let res = await api_getWelfareItemDetail({id: this.$route.query.id})
      this.form = {
        ...res,
      }
    },
    onProductType(type){
      switch (type) {
        case 'WelfareCoupon':

          return '福利券'

        case 'Recharge':

          return '直充商品'

        default:
          return '---'
      }
    },
    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            let params = {
              ...this.form,
              remark: this.form.remark == '<p><br></p>' ? '' : this.form.remark
            }
            // 上传头图
            if (this.form.pictureUrl && this.form.pictureUrl.size) {
              const { key , url } = await api_postFileUpload(this.form.pictureUrl, 'Coupon')
              params.pictureUrl = url
            }
            const res = await api_putWelfareItemUpdate(params)
            console.log('res: ', res);
            this.$baseMessage('操作成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },

    getUploadFile (file, name) {
      this.form[name] = file
    },

    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
  watch: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.market-couponList-create {
  padding: 35px 20px 0 20px;
  padding-bottom: 100px;
  box-sizing: border-box;

  .assign-day {
    display: flex;

    .el-input {
      width: 300px;
    }

    .el-form-item {
      &:last-child {
        .el-input {
          width: 200px;
          margin-left: 5px;
        }
      }
    }
  }
  .market-couponList-create-radio {
    border-bottom: 1px solid #ccc;
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .base-config {
    margin-top: 20px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 30px;
  }

  ::v-deep {
    .el-radio-group {
      .el-radio-button__inner {
        height: 34px;
        padding: 0;
        line-height: 34px;
        margin-right: 1px;
        width: 100px;
        border: 0;
      }

      .el-radio-button:first-child {
        .el-radio-button__inner {
          border-radius: 2px 0px 0 0;
        }
      }

      .el-radio-button:last-child {
        .el-radio-button__inner {
          border-radius: 0 2px 0 0;
        }
      }
    }

    .el-input,
    .el-textarea,
    .el-select {
      width: 350px;
    }

    .short.el-input {
      width: 156px;
    }

    .el-range-editor.el-input__inner {
      width: 350px;
      background: #F2F3F5;
      border: 0;

      input {
        background: #F2F3F5;
        border: 0;
      }
    }

    .el-range-editor.el-input__inner.is-active {
      width: 350px;
      background: #fff;
      border: 1px solid #05C8AF;

      input {
        background: #fff;
        border: 0;
      }
    }

    .desc {
      color: #999;
      font-size: 12px;
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
    z-index: 999;
  }
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
